const MIXIN_PAGE_SENDING_REQUEST = {
  data: () => ({
    isSendingRequest: false
  }),
  methods: {
    setIsSendingRequest (bool) {
      this.isSendingRequest = bool
    },
    startSendingRequest () {
      this.isSendingRequest = true
    },
    finishSendingRequest () {
      this.isSendingRequest = false
    }
  }
}

export {
  MIXIN_PAGE_SENDING_REQUEST
}
